module.exports = __webpack_public_path__ + "media/images/components/c17-covid-19/covid-19-9d50ae857c839903091d6503da51b35f.svg";